var React = require('react');

function BellSchool (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M464 320a48 48 0 0 0-27.14 87.55A40.07 40.07 0 0 1 400 432h-48v48h48a88.08 88.08 0 0 0 86-69.56A47.86 47.86 0 0 0 464 320zM208 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M208 0C93.12 0 0 93.12 0 208s93.12 208 208 208 208-93.12 208-208S322.88 0 208 0zm0 288a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zM64 399.54V480a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-80.46a238.18 238.18 0 0 1-288 0z","className":"fa-primary","key":2})]);
}

BellSchool.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BellSchool;

BellSchool.default = BellSchool;
